import "./HeaderContStyle.css";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaFacebook } from "react-icons/fa";
import { useState } from "react";
import Loader from "../loader/Loader";
import { BiLogoTiktok } from "react-icons/bi";
import { RxLinkedinLogo } from "react-icons/rx";
import { trackSocialClick } from "../../services/socialClicksService";

export default function HeaderContComponent() {
  const [isLoading, setLoading] = useState(false);
  const [copiedNumber, setCopiedNumber] = useState(null);

  const handleCopyNumber = async (number) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(number);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = number;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopiedNumber(number);
      window.setTimeout(() => setCopiedNumber(null), 1200);
    } catch (error) {
      console.error("Erro ao copiar o número:", error);
    }
  };

  async function handleSocialClick(social) {
    setLoading(true);
    try {
      await trackSocialClick(social);
      switch (social) {
        case "tiktok":
          window.location.href = "https://www.tiktok.com/@settefibra";
          break;

        case "linkedin":
          window.location.href =
            "https://www.linkedin.com/company/sette-fibra/";
          break;
        case "facebook":
          window.location.href = "https://www.facebook.com/SETTEFIBRA/";
          break;
        case "instagram":
          window.location.href = "https://www.instagram.com/settefibra/";
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error tracking social click:", error);
    }

    return Promise.resolve();
  }

  return (
    <div className="barraSuperior">
      {isLoading && <Loader />}
      <div className="coloredFrame"></div>
      <div className="frameMsg">
        <div className="callMsg">
          <div className="message">LIGUE OU MANDE UMA MENSAGEM</div>{" "}
          <div className="numberMsg">
            <span
              className={`phone-copy ${
                copiedNumber === "(62) 4051-9377" ? "copied" : ""
              }`}
              role="button"
              tabIndex={0}
              title="Clique para copiar"
              onClick={() => handleCopyNumber("(62) 4051-9377")}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  handleCopyNumber("(62) 4051-9377");
                }
              }}
            >
              (62) 4051-9377
            </span>
            <span
              className={`phone-copy ${
                copiedNumber === "(61) 3686-7700" ? "copied" : ""
              }`}
              role="button"
              tabIndex={0}
              title="Clique para copiar"
              onClick={() => handleCopyNumber("(61) 3686-7700")}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  handleCopyNumber("(61) 3686-7700");
                }
              }}
            >
              (61) 3686-7700
            </span>
          </div>
        </div>
        <span className="icons">
          <span
            onClick={() => {
              handleSocialClick("instagram").then(() => {
                setLoading(false);
              });
            }}
            href="https://www.instagram.com/settefibra/"
            style={{ textDecoration: "none", color: "#fff" }}
          >
            <AiOutlineInstagram className="icon" />
          </span>
          <span
            onClick={() => {
              handleSocialClick("tiktok").then(() => {
                setLoading(false);
              });
            }}
            href="https://www.tiktok.com/@settefibra"
            style={{ textDecoration: "none", color: "#fff" }}
          >
            <BiLogoTiktok className="icon" />
          </span>
          <span
            onClick={() => {
              handleSocialClick("linkedin").then(() => {
                setLoading(false);
              });
            }}
            href="https://www.linkedin.com/company/sette-fibra/"
            style={{ textDecoration: "none", color: "#fff" }}
          >
            <RxLinkedinLogo className="icon" />
          </span>
          <span
            onClick={() => {
              handleSocialClick("facebook").then(() => {
                setLoading(false);
              });
            }}
            href="https://www.facebook.com/SETTEFIBRA/"
            style={{ textDecoration: "none", color: "#fff" }}
          >
            <FaFacebook className="icon" />
          </span>
        </span>
      </div>
    </div>
  );
}
